import { configureIntercom } from '@seek/hirer-intercom-adapter';
import { getLanguageFromLocale, type Locale } from '@seek/melways-sites';
import { useEffect } from 'react';

import type { DashboardAccountContext, EmployerSiteName } from 'src/types';

interface Props {
  accountContext: DashboardAccountContext | null;
  site: EmployerSiteName;
  locale: Locale;
}

export const IntercomConfiguration = ({
  accountContext,
  site,
  locale,
}: Props) => {
  const email = accountContext?.identityContext?.email;
  const name = accountContext?.user?.name;
  const isImpersonating = Boolean(accountContext?.identityContext?.act);

  useEffect(() => {
    if (email && name && !isImpersonating) {
      configureIntercom({
        email,
        name,
        site,
        language: getLanguageFromLocale(locale),
      });
    }
  }, [email, name, isImpersonating, site, locale]);

  return null;
};
